/* eslint-disable */

const featuresByPlan = {
  fullSymbolCurrency: "EUR",
  symbolCurrency: "€",
  annual: {
    planPrices: [
      {
        column: "column-1",
        label: "Free",
        displayPrice: "0",
        price: "0",
        maxParticipants: 50,
        permissionKey: "free",
        upgradeLink:
          "/apps/presentations?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=free_annually",
      },
      {
        column: "column-2",
        label: "Essential",
        price: "7.25",
        maxParticipants: 100,
        permissionKey: "essentialYearly",
        planKey: "essential-yearly",
        upgradeLink:
          "/apps/upgrade/essential-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=essential_annually",
      },
      {
        column: "column-3",
        label: "Pro",
        price: "15.25",
        maxParticipants: "10,000",
        upgradeLink:
          "/apps/upgrade/pro-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=pro_annually",
        permissionKey: "proYearly",
        planKey: "pro-yearly",
      },
      {
        column: "column-4",
        label: "Enterprise",
        price: "Custom",
        maxParticipants: "100,000",
        permissionKey: "enterpriseYearly",
        planKey: "enterprise-yearly",
      },
    ],
  },
  monthly: {
    planPrices: [
      {
        column: "column-1",
        label: "Free",
        displayPrice: "0",
        price: "0",
        maxParticipants: 50,
        permissionKey: "free",
        upgradeLink:
          "/apps/presentations?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=free_monthly",
      },
      {
        column: "column-2",
        label: "Essential",
        price: "22.75",
        maxParticipants: 100,
        permissionKey: "essentialMonthly",
        planKey: "essential-monthly",
        upgradeLink:
          "/apps/upgrade/essential-monthly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=essential_monthly",
      },
      {
        column: "column-3",
        label: "Pro",
        price: "46.75",
        maxParticipants: "10,000",
        permissionKey: "proMonthly",
        planKey: "pro-monthly",
        upgradeLink:
          "/apps/upgrade/pro-monthly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=pro_monthly",
      },
      {
        column: "column-4",
        label: "Enterprise",
        price: "Custom",
        maxParticipants: "100,000",
        permissionKey: "enterpriseMonthly",
        planKey: "enterprise-monthly",
      },
    ],
  },
  educational: {
    planPrices: [
      {
        column: "column-1",
        label: "Free",
        displayPrice: "0",
        price: "0",
        maxParticipants: 50,
        permissionKey: "free",
        upgradeLink:
          "/apps/presentations?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=free_edu",
      },
      {
        column: "column-2",
        label: "Edu Small",
        price: "2.75",
        maxParticipants: 50,
        permissionKey: "eduSmallYearly",
        planKey: "edu-small-yearly",
        upgradeLink:
          "/apps/upgrade/edu-small-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=edu_small",
      },
      {
        column: "column-3",
        label: "Edu Medium",
        price: "4.75",
        maxParticipants: 100,
        permissionKey: "eduMediumYearly",
        planKey: "edu-medium-yearly",
        upgradeLink:
          "/apps/upgrade/edu-medium-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=edu_medium",
      },
      {
        column: "column-4",
        label: "Edu Large",
        price: "7.25",
        maxParticipants: 200,
        permissionKey: "eduLargeYearly",
        planKey: "edu-large-yearly",
        upgradeLink:
          "/apps/upgrade/edu-large-yearly?source=pricingv2&medium=presenter_app&campaign=presenter_app&content=edu_large",
      },
    ],
  },
};

export default featuresByPlan;
